angular.module('unica_partner.partner_services')

.factory('PartnerDeleteService', function ($http, getBaseApiURL) {

	var partnerDeleteService = {};

	partnerDeleteService.delete = function (partnerId)
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/partner/delete/' + partnerId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return partnerDeleteService;
});